import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Stack
} from '@mui/material';
import { APIHOST } from '../../common';
import { useAuth } from '../../components/auth/AuthContext';
import AdminTabs from '../../components/admin/AdminTabs';
import Summary from '../../components/admin/Summary';
import { Hotel } from '@mui/icons-material';
import HotelsPage from './hotel/HotelsPage';

interface User {
  id: number;
  username: string;
  email: string;
  userType: 'internal' | 'admin' | 'user';
}

interface AuthResponse {
  jwt: string;
  user: User;
}

export default function AdminPage() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [credentials, setCredentials] = useState({
    identifier: '',
    password: ''
  });

  // Check if current user has admin access
  const isAuthenticated = currentUser && (currentUser.userType === 'internal' || currentUser.userType === 'admin');

  const handleInputChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setCredentials(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  // Login Form
  if (!isAuthenticated) {
   return <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    Not logged in
      </Box>
  }

  // Admin Dashboard (after authentication)
  return (
    <Box sx={{ minHeight: '100vh', py: 4, mt: 4 }}>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        
        
        <AdminTabs currentPath="/admin" />
        
        <Box sx={{ mt: 3 }}>
          <HotelsPage />
        </Box>
      </Container>
    </Box>
  );
}